import React from 'react';
import { getCompanyUrlFromEmail } from '../../../Modules/TodoList/util';

export interface ViewWebsiteButtonProps {
  email: string;
}

export function ViewWebsiteButton({ email }: ViewWebsiteButtonProps) {
  const companyUrl = getCompanyUrlFromEmail(email);

  if (companyUrl == null) return <></>;

  return (
    <a
      className='flex flex-row v2-group cursor-pointer gap-x-4'
      target='_blank'
      href={companyUrl}
      rel='noreferrer'
    >
      <span className='underline v2-text-neutral-500 group-hover:v2-text-neutral-900 text-base font-thin'>
        View website
      </span>
      <i className='icon icon-popup v2-bg-neutral-500 group-hover:v2-bg-neutral-900 !w-4 !h-4 mt-1' />
    </a>
  );
}
